import { API_IDS, API_TYPES, APIS } from '../assets/constants/apiConstants';
import { getData, getUrl, postData } from './apiRequestUtilities';
import { executeDownloadRequestViaAnchor } from './downloadFile';

export async function cmsDocumentList(options, params) {
  return getData(options, API_IDS.CMS_DOCUMENT_LIST, params);
}
export async function dmDocumentList(options, params) {
  return getData(options, API_IDS.DM_DOCUMENT_LIST, params);
}

//File Downloads
export async function cmsDocumentFileDownload(fileName, mimeType, params) {
  const url = cmsDocumentFileDownloadUrl(params);
  return executeDownloadRequestViaAnchor(fileName, mimeType, url);
}
export async function dmDocumentFileDownload(fileName, mimeType, params) {
  const url = dmDocumentFileDownloadUrl(params);
  return executeDownloadRequestViaAnchor(fileName, mimeType, url);
}

//getURL
export function cmsDocumentFileDownloadUrl(params) {
  const service = `${APIS[API_IDS.CMS_DOCUMENT_FILE_DOWNLOAD]}?${params}`;
  return getUrl(service, API_TYPES.MARKIT_DIGITAL_API);
};
export function dmDocumentFileDownloadUrl(params) {
  const service = `${APIS[API_IDS.DM_DOCUMENT_FILE_DOWNLOAD]}?${params}`;
  return getUrl(service, API_TYPES.MARKIT_DIGITAL_API);
};

//Securities
export async function securitiesSuspensions(options, params) {
  return getData(options, API_IDS.SECURITIES_SUSPENSIONS, params);
}
export async function historicSecuritiesSuspensions(options, params) {
  return getData(options, API_IDS.HISTORIC_SECURITIES_SUSPENSIONS, params);
}
export async function securitiesUpdates(options, params) {
  return getData(options, API_IDS.SECURITIES_UPDATES, params);
}

// RSS
export function rssXmlUrl(Id, params) {
	const service = (`${APIS[API_IDS.RSS_XML_DOWNLOAD]}?${params}`).replace('{Id}', Id);
	return getUrl(service, API_TYPES.MARKIT_DIGITAL_API);
};
export async function rssXmlDownload(Id, params) {
	const url = rssXmlUrl(Id, params);
	return executeDownloadRequestViaAnchor('', '', url);
};

//Subscribe
export async function subscribeToEmailAlerts(emailId) {
  const requestBody = emailId;
  const res = await postData({options: {}, key: API_IDS.SUBSCRIBE_ALERTS, method: 'post', body: requestBody});
  return res.data.success;
}